/**
 * DatePickerModal - Calendar date picker with attendance status colors
 */
import { X } from "lucide-react";

export const DatePickerModal = ({ isOpen, onClose, month, year, onSelectDate, monthNames, attendanceData }) => {
  if (!isOpen) return null;
  
  const daysInMonth = new Date(year, month, 0).getDate();
  const firstDayOfMonth = new Date(year, month - 1, 1).getDay();
  const startOffset = firstDayOfMonth;
  
  const attendanceMap = {};
  if (attendanceData?.attendance) {
    attendanceData.attendance.forEach(child => {
      Object.entries(child.dates || {}).forEach(([date, data]) => {
        if (!attendanceMap[date]) {
          attendanceMap[date] = { present: 0, total: 0 };
        }
        attendanceMap[date].total++;
        if (data.present) {
          attendanceMap[date].present++;
        }
      });
    });
  }
  
  const days = [];
  for (let i = 0; i < startOffset; i++) {
    days.push(null);
  }
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i);
  }
  
  const today = new Date().toISOString().split('T')[0];
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl p-4 max-w-sm w-full shadow-xl" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-gray-800">Pilih Tarikh - {monthNames[month - 1]} {year}</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        <div className="grid grid-cols-7 gap-1 mb-2">
          {["A", "I", "S", "R", "K", "J", "Sa"].map(day => (
            <div key={day} className="text-center text-xs font-bold text-gray-400 py-1">
              {day}
            </div>
          ))}
        </div>
        
        <div className="grid grid-cols-7 gap-1">
          {days.map((day, idx) => {
            if (day === null) {
              return <div key={`empty-${idx}`} className="aspect-square" />;
            }
            
            const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            const dayOfWeek = new Date(year, month - 1, day).getDay();
            const isWeekend = dayOfWeek === 5 || dayOfWeek === 6;
            const isToday = dateStr === today;
            const isFuture = dateStr > today;
            
            const dayAttendance = attendanceMap[dateStr];
            let bgColor = "bg-gray-50 hover:bg-gray-100 text-gray-600";
            
            if (isWeekend) {
              bgColor = "bg-gray-100 text-gray-300 cursor-not-allowed";
            } else if (!isFuture && dayAttendance) {
              if (dayAttendance.present > 0) {
                bgColor = "bg-green-100 hover:bg-green-200 text-green-700";
              } else {
                bgColor = "bg-red-100 hover:bg-red-200 text-red-600";
              }
            } else if (!isFuture && !isWeekend) {
              bgColor = "bg-red-50 hover:bg-red-100 text-red-500";
            }
            
            return (
              <button
                key={day}
                onClick={() => onSelectDate(dateStr)}
                disabled={isWeekend}
                className={`aspect-square rounded-lg font-bold text-sm flex items-center justify-center transition-all
                  ${bgColor}
                  ${isToday ? 'ring-2 ring-blue-500' : ''}`}
              >
                {day}
              </button>
            );
          })}
        </div>
        
        <div className="flex items-center justify-center gap-4 mt-4 pt-3 border-t text-xs">
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-green-100 rounded" />
            <span className="text-gray-500">Hadir</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-red-100 rounded" />
            <span className="text-gray-500">Tidak Hadir</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-gray-100 rounded" />
            <span className="text-gray-500">Cuti</span>
          </div>
        </div>
        
        <button
          onClick={onClose}
          className="w-full mt-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-600 font-medium text-sm"
        >
          Tutup
        </button>
      </div>
    </div>
  );
};
